import { BlueskyPreview } from './BlueskyPreview/BlueskyPreview'
import { FacebookPreview } from './FacebookPreview'
import { GoogleBusinessPreview } from './GoogleBusinessPreview'
import { InstagramPreview } from './InstagramPreview'
import { LinkedInPreview } from './LinkedInPreview'
import { MastodonPreview } from './MastodonPreview'
import { PinterestPreview } from './PinterestPreview'
import { StartPagesPreview } from './StartPagesPreview'
import { SubstackPreview } from './SubstackPreview'
import { ThreadsPreview } from './ThreadsPreview'
import { TikTokPreview } from './TikTokPreview'
import { TwitterPreview } from './TwitterPreview'
import { YoutubePreview } from './YoutubePreview'

export const PREVIEWS_MAP = {
  twitter: {
    title: 'Twitter / X Preview',
    Preview: TwitterPreview,
  },
  mastodon: {
    title: 'Mastodon Preview',
    Preview: MastodonPreview,
  },
  bluesky: {
    title: 'Bluesky Preview',
    Preview: BlueskyPreview,
  },
  facebook: {
    title: 'Facebook Preview',
    Preview: FacebookPreview,
  },
  linkedin: {
    title: 'LinkedIn Preview',
    Preview: LinkedInPreview,
  },
  instagram: {
    title: 'Instagram Preview',
    Preview: InstagramPreview,
  },
  googlebusiness: {
    title: 'Google Business Profile Preview',
    Preview: GoogleBusinessPreview,
  },
  startPage: {
    title: 'Start Page Preview',
    Preview: StartPagesPreview,
  },
  tiktok: {
    title: 'TikTok Preview',
    Preview: TikTokPreview,
  },
  pinterest: {
    title: 'Pinterest Preview',
    Preview: PinterestPreview,
  },
  youtube: {
    title: 'YouTube Short Preview',
    Preview: YoutubePreview,
  },
  threads: {
    title: 'Threads Preview',
    Preview: ThreadsPreview,
  },
  substack: {
    title: 'Substack Preview',
    Preview: SubstackPreview,
  },
}
